<template>
    <section>
      <v-img
        :src="app.logo"
        class="mb-8"
        :lazy-src="app.logo"
        :max-width="brand"
      ></v-img>
    </section>
</template>

<script>
import app from '@/config/app'

export default {
  data: () => ({
    app,
    brand: 250,
  }),
}
</script>

